import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Sparkles, AlertCircle } from 'lucide-react';

const SubscriptionBanner = () => {
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get('/billing/me').then((r) => setMe(r.data)).catch(() => null);
  }, []);

  if (!me) return null;

  if (me.status === 'granted' || me.status === 'active' || me.status === 'free') {
    return null;
  }

  if (me.status === 'trial') {
    const urgent = me.days_left !== null && me.days_left <= 7;
    return (
      <div
        className={`flex items-center justify-center gap-3 px-4 py-2 text-sm ${
          urgent ? 'bg-orange-100 text-orange-900 border-b border-orange-200' : 'bg-blue-50 text-blue-800 border-b border-blue-100'
        }`}
        data-testid="trial-banner"
      >
        <Sparkles className="w-4 h-4 shrink-0" />
        <span>
          Essai gratuit — il vous reste{' '}
          <strong>
            {me.days_left} jour{me.days_left > 1 ? 's' : ''}
          </strong>
          .
        </span>
        <Link to="/pricing" className="underline font-medium hover:text-slate-900">
          Choisir un abonnement →
        </Link>
      </div>
    );
  }

  if (me.status === 'expired') {
    return (
      <div
        className="flex items-center justify-center gap-3 px-4 py-2 text-sm bg-red-50 text-red-800 border-b border-red-200"
        data-testid="expired-banner"
      >
        <AlertCircle className="w-4 h-4 shrink-0" />
        <span>
          <strong>Votre essai est terminé.</strong> Vous ne pouvez plus créer ni envoyer de documents.
        </span>
        <Link to="/pricing" className="underline font-bold hover:text-red-900">
          Souscrire maintenant →
        </Link>
      </div>
    );
  }

  return null;
};

export default SubscriptionBanner;
